<template>
  <div class="order_detail" v-if="loading">
    <nav-bar/>
    <search-bar/>
    <div class="main fz14">
      <div class="nav">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/me/myorder' }">我的订单</el-breadcrumb-item>
          <el-breadcrumb-item>质量反馈</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="info_box">
        <div class="info mb20">
          <div class="fr ac fz12 mt20">
            <div class="center order_list_item">产品信息</div>
            <div class="center order_list_item">产品规格</div>
            <div class="center order_list_item">设备信息</div>
            <div class="center order_list_item">配套工艺</div>
            <div class="center order_list_item">产品价格</div>
            <div class="center order_list_item">数量</div>
            <div class="center order_list_item">小计</div>
          </div>
          <el-divider/>
          <div class="order-list fz12">
            <div class="order-item mt20">
              <!--                上-->
              <div class="top">
                <span>{{ order_detail.create_time }}</span>
                <span class="ml20 grey">订单编号：{{ order_detail.order_no }}</span>
                <span class="ml40 blue" v-html="order_state_decide(order_detail)"></span>
              </div>
              <!--                中-->

              <div class="fr middle">
                <!-- 商品信息 -->
                <div class="order">
                  <template v-for="(goods,i) in order_detail.orderGoodsBeans">
                    <div
                        class="fr jc ac order_left"
                        :key="i"
                        v-show="goods.order_goods_id == order_goods_id"
                    >
                      <div class="fr afs pl10 pr20 pt20 pb20 order_list_item">
                        <el-image class="goods_img fs mr10" :src="goods.goods_img" alt/>
                        <p class>{{ goods.goods_name }} {{ goods.goods_standard_name }}</p>
                      </div>
                      <div class="center order_list_item"> {{ specNameInit(goods) }}</div>
                      <div class="center order_list_item">{{ goods.device_id ? goods.device_id : '-' }}</div>

                      <div class="center cursor order_list_item blue">
                        {{
                          goods.goods_type == 1 ?
                              "￥" + goods.goods_craft_price : '-'
                        }}
                      </div>
                      <div class="center order_list_item">￥{{ goods.goods_price }}</div>
                      <div class="center order_list_item">{{ goods.goods_num }}</div>
                      <div class="center order_list_item red">￥{{ goods.goods_total_price }}</div>
                    </div>
                  </template>
                </div>
              </div>

              <!--                下-->
              <div class="p20 fz14 bottom" style="text-align: right">
                <div>
                  <span>订单金额</span>
                  <span class="blue">￥{{ order_detail.order_total_price }}</span>
                </div>
                <div class="mt10">
                  <span>已付款</span>
                  <span>￥{{ order_detail.pay_price }}</span>
                </div>
                <div class="mt10">
                  <span>未付款</span>
                  <span class="red">￥{{ sub(order_detail.order_actual_price, order_detail.pay_price) }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="price_box">
          <el-form label-width="140px" style="width: 600px;">
            <el-form-item label="联系人">
              <el-select size="small" v-model="contact_name" placeholder="请选择联系人" @change="selectWorkMate">
                <el-option
                    v-for="item in workmate_list"
                    :key="item.member_id"
                    :label="item.member_nick_name"
                    :value="item.member_nick_name">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="联系电话">
              <el-input size="small" v-model="contact_mobile" placeholder="请输入联系电话"/>
            </el-form-item>
            <el-form-item label="反馈描述">
              <el-input
                  v-model="feedback_desc"
                  type="textarea"
                  resize="none"
                  rows="3"
                  placeholder="请输入反馈内容"
                  size="small"
              />
            </el-form-item>
            <el-form-item label="反馈图片">
              <up-load :file_list.sync="feedback_imgs" :limit="6"/>

            </el-form-item>
          </el-form>
          <div class="fr ac jc">
            <el-button type="primary" size="small" @click="submit">提交反馈</el-button>
          </div>
        </div>
      </div>
    </div>
    <footer-bar/>
  </div>
</template>

<script>
import NavBar from "@/components/NavBar";
import SearchBar from "@/components/SearchBar";
import FooterBar from "@/components/FooterBar";
import Upload from "@/components/UploadImg";

export default {
  data() {
    return {
      order_detail: {},
      loading: false,
      feedback_desc: "",
      feedback_imgs: [],
      workmate_list: [],
      order_goods_id: "",
      contact_name: "",
      contact_mobile: "",
    };
  },
  created() {
    this.order_goods_id = this.$route.query.goods_id;
    this.getOrderDetail();
    this.getCompanyWorkmateList();
  },
  methods: {
    selectWorkMate(i) {
      let obj = this.workmate_list.filter(el => {
        return el.member_nick_name === i
      })[0]
      this.contact_mobile = obj.member_account;
    },
    getCompanyWorkmateList() {
      this.post("memberRoleInterfaces/v1.0/getCompanyWorkmateList", {}).then(res => {
        this.workmate_list = res.data;
      })
    },
    // 订单详情
    getOrderDetail() {
      this.post("orderInterfaces/v1.0/getOrderDetail", {
        order_id: this.$route.query.id
      }).then(res => {
        this.order_detail = res.data;
        this.loading = true;
      });
    },
    submit() {
      if (this.is_Empty(this.contact_name)) {
        this.$message({
          message: "请输入联系人",
          type: "warning"
        });
        return;
      }
      if (this.is_Empty(this.contact_mobile)) {
        this.$message({
          message: "请输入联系电话",
          type: "warning"
        });
        return;
      }
      if (!this.checkPhone(this.contact_mobile)) {
        this.$message({
          message: "请输入正确的联系电话",
          type: "warning"
        });
        return;
      }
      if (!this.feedback_desc.length) {
        this.$message({
          message: "请输入反馈内容",
          type: "warning"
        });
        return;
      }
      this.post("orderInterfaces/v1.0/insertOrderFeedback", {
        order_id: this.$route.query.id,
        order_goods_id: this.$route.query.goods_id,
        contact_name: this.contact_name,
        contact_mobile: this.contact_mobile,
        feedback_desc: this.feedback_desc,
        feedback_imgs: this.feedback_imgs.join(",")
      }).then(res => {
        setTimeout(() => {
          this.back();
        }, 2000)
        this.$message({
          type: "success",
          message: "已发起"
        });
      });
    }
  },
  components: {NavBar, SearchBar, FooterBar, "up-load": Upload}
};
</script>

<style scoped lang="scss">
.order_detail {
  .main {
    width: 1200px;
    margin: 0 auto;
    padding: 20px 0;
    .el-select{
         width: 100%;
       }
    .nav {
      background-color: #fff;
      padding: 20px;
      margin-bottom: 20px;
    }

    .info_box {
      background-color: #fff;
      padding: 20px;

      .info {
        background-color: #fff;

        .order_list_item {
          &:nth-of-type(1) {
            width: 400px;
          }

          &:nth-of-type(2) {
            width: 130px;
          }

          &:nth-of-type(3) {
            width: 130px;
          }

          &:nth-of-type(4) {
            width: 130px;
          }

          &:nth-of-type(5) {
            width: 130px;
          }

          &:nth-of-type(6) {
            width: 130px;
          }

          &:nth-of-type(7) {
            width: 130px;
          }
        }

        .order-list {
          .order-item {
            border: 1px solid #e5e5e5;

            .top {
              background-color: #f0f6ff;
              padding: 14px;
            }

            .middle {
              border-bottom: 1px solid #e5e5e5;

              .order {
                .order_left {
                  border-right: 1px solid #e5e5e5;
                  border-bottom: 1px solid #e5e5e5;

                  &:last-child {
                    border-bottom: none;
                  }

                  .goods_img {
                    width: 80px;
                    height: 80px;
                  }
                }

                .operating {
                  p {
                    margin-top: 10px;

                    &:nth-of-type(1) {
                      margin-top: 0;
                    }
                  }
                }
              }
            }
          }
        }
      }

      .price_box {
        .price_item {
          img {
            width: 100px;
            height: 100px;
            margin-right: 10px;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/me/myorder/Feedback.vue